<template>
  <!-- <div class="row no-wrap">
    <div class="trade__date col-6 items-center text-center">
      <div class="trade__date-title">
        {{ $t('booking.checkInDate') }}
      </div>
      <div class="trade__date-value">
        {{ $filters.formatShortDate(tradesub[0]?.checkindate) }}
      </div>
    </div>
    <div class="trade__date col-6 trade items-center text-center">
      <div class="trade__date-title">
        {{ $t('booking.checkOutDate') }}
      </div>
      <div class="trade__date-value">
        {{ $filters.formatShortDate(tradesub[0]?.checkoutdate) }}
      </div>
    </div>
  </div> -->
  <div class="column text-center">
    <!-- <div
      class="trade__active col-12 q-pa-sm"
      v-html="
        $t('trade.roomCnt', {
          name: tradesub[0]?.name,
          quantity: tradesub[0]?.buycnt,
          price: tradesub[0]?.sumprice,
        })
      "
    ></div> -->
    <q-btn
      class="full-width"
      color="primary"
      outline
      :label="$t('trade.details')"
      :to="{ name: 'TradeDetail', params: { serno: trade.serno } }"
      @click="goDetail"
    />
    <q-btn
      class="full-width"
      color="primary"
      outline
      :label="$t('trade.takeRoomCard')"
      :to="{ name: 'AccountTakeRoomCard', params: { serno: trade.serno } }"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  props: {
    trade: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      tradesub: [],
    };
  },
  created() {
    this.getTradesub(this.trade.serno)
      .then((res) => {
        this.tradesub = res;
      })
      .catch((err) => {
        console.log(err);
        this.$notify.create({
          type: 'negative',
          position: 'top',
          message: this.$t('trade.getInfo.failed'),
          caption: err.response.data,
        });
      });
  },
  methods: {
    ...mapActions({
      getTradesub: 'trade/getTradesub',
    }),

    goDetail() {
      this.$router.push({
        name: 'TradeDetail',
        params: {
          serno: this.serno,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/quasar.variables.scss';

.trade {
  &__date {
    border: 1px solid $text-gray;

    &-title {
      color: $primary;
    }

    &-value {
      font-size: 1.2rem;
    }
  }

  &__active {
    border: 1px solid $text-gray;
    // font-size: 0.7rem;
  }
}
</style>
